<template>
  <div class="pycad-view-controls">
    <button
      v-if="showReset"
      type="button"
      class="pycad-view-controls__btn"
      title="Reset camera"
      @click="emit('reset')"
    >
      <i class="mdi mdi-camera-flip-outline"></i>
    </button>
    <button
      v-if="showMaximize"
      type="button"
      class="pycad-view-controls__btn"
      :class="{ 'pycad-view-controls__btn--active': isMaximized }"
      :title="isMaximized ? 'Restore layout' : 'Maximize view'"
      @click="emit('toggle-maximize')"
    >
      <i
        :class="[
          'mdi',
          isMaximized ? 'mdi-arrow-collapse' : 'mdi-arrow-expand',
        ]"
      ></i>
    </button>
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    showReset?: boolean;
    showMaximize?: boolean;
    isMaximized?: boolean;
  }>(),
  {
    showReset: true,
    showMaximize: true,
    isMaximized: false,
  }
);

const emit = defineEmits<{
  (e: 'reset'): void;
  (e: 'toggle-maximize'): void;
}>();
</script>

<style scoped>
.pycad-view-controls {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 10px;
  background: rgba(5, 5, 5, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
  pointer-events: auto;
}

.pycad-view-controls__btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: transparent;
  border: 1px solid transparent;
  color: #a0a0a0;
  cursor: pointer;
  outline: none;
  padding: 0;
  font-family: inherit;
  transition: all 0.15s ease;
}

.pycad-view-controls__btn .mdi {
  font-size: 15px;
  line-height: 1;
}

.pycad-view-controls__btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.pycad-view-controls__btn--active {
  background: rgba(255, 153, 0, 0.15);
  border-color: rgba(255, 153, 0, 0.45);
  color: #ff9900;
  box-shadow: 0 0 10px rgba(255, 153, 0, 0.25);
}
</style>
